import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SavedDataMultipoint } from '../../new-contract-pymes-multipoint.model';
import { NewContractPymesMultipointService } from '../../new-contract-pymes-multipoint.service';

@Component({
  selector: 'app-multipoint-modal-resume',
  templateUrl: './multipoint-modal-resume.component.html',
  styleUrls: ['./multipoint-modal-resume.component.scss']
})
export class MultipointModalResumeComponent implements OnInit {
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  public socialReason = false;
  public contract: SavedDataMultipoint;

  constructor(
    private dialogRef: MatDialogRef<MultipointModalResumeComponent>,
    private newContractPymesMultipointService: NewContractPymesMultipointService,
    @Inject(MAT_DIALOG_DATA) public indexTab: number
  ) { }

  ngOnInit(): void {
    this.newContractPymesMultipointService.getSavedDataMultipoint().pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        this.contract = response;
        this.destroyed$.next();
        this.destroyed$.complete();
      }
    );
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public handleSocialReason(): void {
    this.socialReason = !this.socialReason;
  }
}
